export function normalisePublicInviteCode(raw: string): string {
  return raw.trim().toUpperCase();
}

export function hasInviteControlCharacter(raw: string): boolean {
  return Array.from(raw).some((character) => {
    const codePoint = character.codePointAt(0) ?? 0;
    return codePoint <= 0x1f || codePoint === 0x7f;
  });
}
